<template>
  <div class="module-afiliasi">
    <SOSlotBase :container-name="'landing-page-affiliasi-content'">
      <template v-slot:title-bar>
        <div>
          <SOTitleBar :page-title="'Afiliasi'" :type="'back'" @back="back" />
        </div>
      </template>

      <template v-slot:content>
        <div class="affiliasi-content">
          <div class="afiliasi-img">
            <img src="@/assets/img/illustrator-invitations.svg" alt="" />
          </div>
          <div class="afiliasi-text">
            <p class="f-16 f-bold f-c-black m-d-8">Ajak Teman Menjadi Owner</p>
            <p class="f-14 f-regular f-c-midgrey m-d-8">
              Dapatkan benefit senilai <span class="f-bold">30% dari biaya aktivasi outlet</span> untuk setiap teman
              yang diajak
            </p>
          </div>
          <div class="afiliasi-btn">
            <SOButton
              :primary="true"
              :full="true"
              :text="'Daftar Sekarang'"
              :id="`afiliasi-btn-request`"
              :disable="isFetching"
              :loading="isFetching"
              @action="onRegister"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
  name: "WelcomePage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.isRegistered === "true") {
        vm.$router.push({ name: "afiliasi.dashboard" });
      } else {
        vm.registerStatus();
      }
    });
  },
  watch: {
    getResponse: function(newRes, oldRes) {
      if (newRes !== oldRes) {
        if (newRes.success) {
          this.$router.push({ name: "afiliasi.dashboard" });
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      isFetching: "isFecthing",
      getResponse: "getResponse",
    }),
    isRegistered() {
      return localStorage.getItem("isAfiliator");
    },
  },
  methods: {
    ...mapActions({
      registerStatus: `${moduleName}/registerStatus`,
    }),
    back() {
      this.$router.push({ name: "dashboard" });
    },
    onRegister() {
      this.$router.push({ name: "afiliasi.terms" });
      this.smartTrackingClick("register_afiliasi");

    },
  },
};
</script>

<style scoped>
.affiliasi-content {
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  height: 90vh;
  width: 100vw;
  position: fixed;
}

.afiliasi-img {
  align-self: end;
}

.afiliasi-text {
  padding: 0px 32px;
  text-align: center;
}

.afiliasi-btn {
  align-self: baseline;
  width: 100%;
  padding: 0px 20px;
}
</style>
